import { useEffect, useState } from 'react';

export default function LoadingDots({
  colour = 'text-gray-700',
  size = 'text-lg',
  className = '',
}) {
  const [dots, setDots] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev === 3 ? 1 : prev + 1));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`inline-flex ${size} ${className}`}>
      <span
        className={`${colour} transition-opacity duration-300 ${dots >= 1 ? 'opacity-100' : 'opacity-30'}`}
      >
        .
      </span>
      <span
        className={`${colour} transition-opacity duration-300 ${dots >= 2 ? 'opacity-100' : 'opacity-30'}`}
      >
        .
      </span>
      <span
        className={`${colour} transition-opacity duration-300 ${dots === 3 ? 'opacity-100' : 'opacity-30'}`}
      >
        .
      </span>
    </div>
  );
}
